module.exports = __webpack_public_path__ + "img/fwx2.f77e5816.png";